import React from "react";

import { IonList, IonItem, IonSkeletonText, IonLabel } from "@ionic/react";

export interface IonListLoadingProps {
  items?: number | 10;
  item?: React.ReactElement;
  label?: React.ReactElement;
  labelWidth?: string | "50%" | "100%";
}

export const IonListLoading: React.FC<IonListLoadingProps> = ({
  item,
  label,
  labelWidth,
}) => {
  const listLoading = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <IonList>
      {listLoading.map((value, i) => (
        <IonItem
          key={value}
          lines={listLoading.length === i + 1 ? "none" : undefined}
        >
          {item}
          <IonLabel>
            {label ? (
              label
            ) : (
              <h3>
                <IonSkeletonText animated style={{ width: labelWidth }} />
              </h3>
            )}
          </IonLabel>
        </IonItem>
      ))}
    </IonList>
  );
};
